// Variable utility functions for CANmail

// Available variables for CANmail (only the three requested)
export const AVAILABLE_VARIABLES = [
  { key: "first_name", label: "First Name", description: "Contact's first name", example: "John" },
  { key: "last_name", label: "Last Name", description: "Contact's last name", example: "Doe" },
  { key: "company", label: "Company", description: "Contact's company name", example: "Acme Corp" },
];

// Variable regex pattern - using [[ ]] to avoid JSX parsing issues
export const VARIABLE_REGEX = /\[\[([^\]]+)\]\]/g;

/**
 * Get all variables used in content
 * @param {string} content - The content to analyze
 * @returns {Array} - Array of variable keys
 */
export function getUsedVariables(content) {
  if (!content) return [];
  
  const matches = [...content.matchAll(VARIABLE_REGEX)];
  const uniqueVars = [...new Set(matches.map(match => match[1]))];
  
  return uniqueVars;
}

/**
 * Validate variable syntax
 * @param {string} content - The content to validate
 * @returns {Object} - Validation result with errors array
 */
export function validateVariables(content) {
  if (!content) return { isValid: true, errors: [] };
  
  const errors = [];
  const matches = [...content.matchAll(VARIABLE_REGEX)];
  
  matches.forEach((match) => {
    const variableName = match[1];
    const variable = AVAILABLE_VARIABLES.find(v => v.key === variableName);
    
    if (!variable) {
      errors.push({
        type: "unknown_variable",
        message: `Unknown variable: [[${variableName}]]`,
        position: match.index,
        variable: variableName
      });
    }
  });
  
  // Check for malformed variables (missing closing brackets)
  const malformedRegex = /\[\[[^\]]*$/g;
  const malformedMatches = content.match(malformedRegex);
  if (malformedMatches) {
    malformedMatches.forEach(match => {
      errors.push({
        type: "malformed_variable",
        message: "Malformed variable - missing closing brackets",
        position: content.indexOf(match),
        variable: match
      });
    });
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}
